export const loadStripeSdk = () => {
    if (window.Stripe) {
        callback();
        return;
    }
    let url = `https://js.stripe.com/v3`;
    // if (disableAdvancedFraudDetection) url += '?advancedFraudSignals=false';
    const e = document.createElement('script');
    e.src = url;
    e.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(e);
    // e.addEventListener('load', callback);
};